import LayoutStatic from "@/layouts/LayoutStatic/LayoutStatic.vue";

export default {
    components: {
        LayoutStatic
    },
    data() {
        return {
            layout: LayoutStatic
        };
    },
    mounted() {
        if (typeof window.__PRERENDER_INJECTED !== "undefined") this.$nextTick(() => { window.document.dispatchEvent(new CustomEvent("spa-render-complete")); });
    }
};



// WEBPACK FOOTER //
// ./src/pages/PageNotFound/PageNotFound.js